import React, { useState } from 'react';
import { Button } from 'antd';

import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import BasePageCard from 'components/wrappers/BasePageCard';
import BaseAlert from 'components/wrappers/BaseAlert';
import { getCorporateTATimesheetApproverInformation } from 'redux/reducers/recruiterSlice';
import TimesheetApproverCard from 'features/account/AdditionalInfo/TimesheetApproverInfo/TimesheetApproverCard';
import EditTimesheetApproverInfoModal from 'features/account/AdditionalInfo/TimesheetApproverInfo/EditTimesheetApproverInfoModal';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function TimesheetApproverInfoSection(props: Props) {
  const { corporateInfo } = props;
  const dispatch = useAppDispatch();
  const [timesheetApproverInfo, setTimesheetApproverInfo] = useState(
    corporateInfo?.timesheetApprovers,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const loadTimesheetApproverInfo = async () => {
    const result = await dispatch(
      getCorporateTATimesheetApproverInformation(corporateInfo?.companyId),
    );

    if (getCorporateTATimesheetApproverInformation.fulfilled.match(result)) {
      setTimesheetApproverInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <>
      {isModalVisible && (
        <EditTimesheetApproverInfoModal
          companyId={corporateInfo?.companyId}
          onClose={() => setIsModalVisible(false)}
          onEdit={loadTimesheetApproverInfo}
          timesheetApproverInfo={timesheetApproverInfo}
        />
      )}

      <BasePageCard
        title="Timesheet approver information"
        className="stretch-card"
        icons={<span className="icon icon-timesheet-clock"></span>}
        subTitle={
          <Button
            onClick={() => setIsModalVisible(true)}
            className="with-icon mobile-icon-only"
            size="large"
            icon={<span className="icon icon-edit" />}
          >
            Edit
          </Button>
        }
      >
        <div className="scroll-box">
          {!timesheetApproverInfo?.length && (
            <div className="content-wrapper">
              <BaseSectionMessage
                type="info"
                title="Info"
                message={
                  <span>
                    Waiting for member to respond. Timesheet approver
                    information will be displayed after a member enters the
                    data.
                  </span>
                }
              />
            </div>
          )}

          {!!timesheetApproverInfo?.length && (
            <>
              {timesheetApproverInfo.map((timesheetApprover, index) => (
                <TimesheetApproverCard
                  key={index}
                  timesheetApprover={timesheetApprover}
                />
              ))}
            </>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
